import { Schema } from '@core/data/dto/schema';

export const PaystubSchema = {
    id: Schema.String,
    gross_total: Schema.Number,
    net_total: Schema.Number,
    net_pay: Schema.Number,
    payday: Schema.Moment,
    payroll_id: Schema.String,
    period_start: Schema.Moment,
    period_end: Schema.Moment,
    provider: Schema.String,
    provider_id: Schema.String,
    status: Schema.String,
    status_message: Schema.String,
    tax_total: Schema.Number
}
